export enum EGiftOrderStatuses {
  NEW = 'NEW',
  CANCELED = 'CANCELED',
  IN_PROGRESS = 'IN_PROGRESS',
  SENT = 'SENT',
}

export enum EGiftOrderStatusesCodes {
  CANCELED = 2,
  IN_PROGRESS = 1,
  SENT = 3,
}

export const giftOrderFilterStatuses = [
  {
    text: 'New',
    value: 'NEW',
  },
  {
    text: 'Cancel',
    value: 'CANCELED',
  },
  {
    text: 'In progress',
    value: 'IN_PROGRESS',
  },
  {
    text: 'Sent',
    value: 'SENT',
  },
]

export const colorGiftOrderStatuses = (status: string) => {
  switch (status) {
    case EGiftOrderStatuses.NEW:
      return 'yellow'
    case EGiftOrderStatuses.CANCELED:
      return '#e55353'
    case EGiftOrderStatuses.IN_PROGRESS:
      return '#321fdb'
    case EGiftOrderStatuses.SENT:
      return '#2eb85c'
    default:
      return '#d4b106'
  }
}
